import { Chart } from 'chart.js';
import { createApp } from 'vue/dist/vue.esm-bundler';

import globalMixin from './globalMixin'

import VideosHistoricalStats from "./cards/VideosHistoricalStats.vue"
import TopGeoAreas from "./cards/TopGeoAreas.vue"
import TickerGraph from "./cards/TickerGraph.vue"

window.Chart = Chart

createApp({
    components: {
        VideosHistoricalStats,
        TopGeoAreas,
        TickerGraph,
    },
    mixins: [globalMixin],
    created() {
        this.initChartJs()
        this.initDatePicker()
    }
}).mount('#content')
